module.exports = __webpack_public_path__ + "static/media/logo-priceminister.b4ec81a9.png";